import React from 'react';

export interface SvgIconProps {
  accessibilityLabel?: string;
  color?: string;
  size?: number | string;
  children?: React.ReactElement<any> | React.ReactElement<any>[];
  className?: string;
  fill?: string;
  role?: string;
  viewBox?: string;
  height?: string | number;
  width?: string | number;
  component?: React.ReactType<SvgIconProps>;
}

export const SvgIcon: React.StatelessComponent<SvgIconProps> = (props: SvgIconProps) => {
  const {
    children,
    className,
    color = 'inherit',
    component: Component = 'svg',
    accessibilityLabel = '',
    viewBox = '0 0 24 24',
    size = 24,
    ...other
  } = props;

  const hasAccessibilityLabel = accessibilityLabel && accessibilityLabel !== '';

  return (
    //@ts-ignore
    <Component
      className={className}
      viewBox={viewBox}
      color={color}
      fill="currentColor"
      aria-hidden={!hasAccessibilityLabel}
      role={hasAccessibilityLabel ? 'img' : 'presentation'}
      height={size}
      width={size}
      aria-label={accessibilityLabel}
      {...other}
    >
      {children}
      {accessibilityLabel ? <title>{accessibilityLabel}</title> : null}
    </Component>
  );
};
